import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { showBudgetBidCampaignNotifications } from '@bingads-webui-campaign/import-shared-utils';
import unpurposedBudgetTemplate from './unpurposed-budget-template.pug';
import budgetTemplate from './lifetime-budget-template.pug';

const LifetimeBudgetType = 'LifetimeBudgetStandard';

export class LifetimeBudgetColumn extends CampaignuiBaseColumn {
  constructor(options) {
    const title = options.i18n.getString('ColumnName_LifetimeBudgetAmount');

    super({
      name: 'LifetimeBudget',
      property: ['Budget'],
      title,
      sortable: 'Budget/LifetimeBudgetAmount',
      editable: true,
      enableEdit: item => item.Budget?.Type === LifetimeBudgetType,
      type: 'number',
      helpId: 'pop_BA_Campaigns_BudgetType_Total',
      helpAriaLabel: options.i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.view = options.view;
    this.i18n = options.i18n;
    this.InlineBudgetEditor = options.InlineBudgetEditor;
    this.budgetTemplate = budgetTemplate;
    this.decimal = options.decimal;
    this.permissions = options.permissions;
    this.isForVNext = options.isForVNext;
    this.isCampaign = options.isCampaign;
  }

  pickProperty(item) {
    const properties = {
      Budget: item.Budget,
      DeliveryStatus: item.DeliveryStatus,
      IsBidLandscapeAvailable: item.IsBidLandscapeAvailable,
      BiddingScheme: item.BiddingScheme,
      DeliveryStatusDetails: item.DeliveryStatusDetails,
      BidStrategyName: item.BidStrategyName,
    };
    properties.AssociatedExperiment = item.AssociatedExperiment;
    return properties;
  }

  onPrompt({
    position, item, newPosition,
  }) {
    const groupClass = `grid-group-${_.result(this.config, 'group', 'other')}`;
    const { instrumentation } = this.view;
    let budgetBidCampaignImportNotificationActivity;
    if (instrumentation) {
      budgetBidCampaignImportNotificationActivity = instrumentation.createScenarioAndActivity({
        scenarioName: 'BudgetBidCampaignImportNotification',
        activityName: 'CampaignsGridBudgetColumn',
      }).activity;
    }


    if (item.Budget.LifetimeBudgetAmount) {
      const editor = new this.InlineBudgetEditor({
        item,
        $elToBlock: this.view.grid.gridView.$el,
        isForVNext: this.isForVNext,
        permissions: this.permissions,
        showBudgetMinRecommend: this.permissions.dynamic && this.permissions.dynamic.BCCBudgetImprovementEnabled,
        currencySymbol: this.i18n.getCurrencySymbol(),
        clientName: this.isCampaign ? 'CampaignTabEditing' : 'AllCampaignSetting',
        perfMarker: this.view.campaignTabPerfMarker,
        importNotificationCallback: (newBudget) => {
          showBudgetBidCampaignNotifications({
            campaignItemList: [item], oldBudget: item.Budget, newBudget, activity: budgetBidCampaignImportNotificationActivity,
          });
        },
      });

      editor.on('close', (update) => {
        if (update) {
          this.view.grid.gridView.refresh(true);
        }
      });

      const editorView = new GridCustomizedPopupEditor({
        editorView: editor.render(),
        cellPosition: this.isForVNext ? newPosition : position,
        renderBelow: false,
        className: 'grid-popupeditor'.concat(` ${groupClass}`).concat(this.permissions.IsBudgetInlineSuggestionEnabled ? ' inline-budget-editor-popup' : ''),
        parentContainerSelector: this.isForVNext ? '.grid-and-disclaim-container' : null,
      });

      editorView.render();
      return editorView;
    }
    return _.noop;
  }

  template({ value }) {
    let params = null;
    if (value.Budget) {
      if (value.Budget.Type && value.Budget.Type !== LifetimeBudgetType) {
        return unpurposedBudgetTemplate();
      }

      // aggregated row budget
      if (_.isNumber(value.Budget.LifetimeBudget)) {
        params = {
          budgetAmount: this.decimal.fromFloatToString(value.Budget.LifetimeBudget),
          budgetType: LifetimeBudgetType,
          i18n: this.i18n,
        };
      } else {
        params = {
          budgetAmount: value.Budget.LifetimeBudgetAmount ? this.decimal.fromFloatToString(value.Budget.LifetimeBudgetAmount) : '',
          budgetType: value.Budget.Type,
          i18n: this.i18n,
        };
      }
    }

    return this.budgetTemplate({
      model: params,
    });
  }
}
